import * as React from 'react';

import routes from 'defs/routes';

import i18n from 'helper/i18n';
import { template } from 'helper/string';

import Coach from 'components/atoms/Coach';
import Link from 'components/atoms/Link';
import Bevel from 'components/helper/Bevel';
import { CoachIsEnumType } from '../../CoachSelector/CoachSelector';

export type ProgramFinishProps = {
	coachMotivation: string;
	totalNumberOfDays: number;
	percentageFinished: number;
	onCloseNotification: Function;
	coach: CoachIsEnumType;
};

const ProgramFinish = ({
	coachMotivation,
	totalNumberOfDays,
	percentageFinished,
	onCloseNotification,
	coach,
}: ProgramFinishProps) => (
	<div className="m-program-finish">
		<div className="container">
			<div className="row">
				<div className="col-xs-12 col-sm-12 col-md-6 col-md-offset-6">
					<div className="m-program-finish__info">
						<h2 className="m-program-finish__title">
							{i18n(`react.impulsCoach.molecules.ProgramFinish.${coachMotivation}.title`)}
						</h2>
						<h3 className="m-program-finish__sub">
							{i18n(`react.impulsCoach.molecules.ProgramFinish.${coachMotivation}.sub`)}
						</h3>

						<p className="m-program-finish__text">
							{template(i18n(`react.impulsCoach.molecules.ProgramFinish.${coachMotivation}.text`), {
								days: totalNumberOfDays,
								percent: `${percentageFinished}%`,
							})}
						</p>

						<div className="m-program-finish__link">
							<Link
								modifier="button"
								title={i18n('react.impulsCoach.molecules.ProgramFinish.newProgram')}
								href={routes.program.recommended.href}
								iconRight="link-arrow"
								onClick={() => onCloseNotification()}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-xs-12 col-sm-12 col-md-6">
					<div className="m-program-finish__coach-box">
						<div className="m-program-finish__coach-wrap">
							<Coach coach={coach} gesture="front-top" alt="Coach" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<Bevel modifier="bottom-left" color="006E78" />
	</div>
);

export default ProgramFinish;
